// extracted by mini-css-extract-plugin
export default {"Media":"Media-module__Media--XNCZb"};